<div class="del_popup_box">
    <form class="my-4">
        <div class="justify-content-center">
            <div class="col-lg-12 text-center d-flex justify-content-center">
                <div class="delete_img_div">
                    <img src="assets/img/trash-bin.png" class="delete_img" alt="">
                </div>
            </div>
            <div class="col-lg-12 text-center my-4">
                <p class="delete_text">Are you sure you want to delete</p>
            </div>
            <div class="col-lg-12 text-center">
                <button type="button" class="btn btn-secondary mx-3" data-dismiss="modal" (click)="closeModal()">Close</button>
                <button type="button" class="btn btn-danger padding_del_btn" (click)="deleteSchool()">Delete</button>
            </div>
        </div>
    </form>
</div>